<div *ngIf="show"
    class="rounded-lg border border-l-4 px-4 py-3 shadow-app-toast"
    [ngClass]="getAlertClasses()" [ngStyle]="getAlertStyle()" aria-live="polite" role="alert">
    <div class="flex items-start gap-3">
        <span class="inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md" [ngClass]="getIconClasses()" aria-hidden="true">
            <i *ngIf="type === 'success'" class="bi bi-check-circle-fill app-icon"></i>
            <i *ngIf="type === 'danger'" class="bi bi-exclamation-octagon-fill app-icon"></i>
            <i *ngIf="type === 'warning'" class="bi bi-exclamation-triangle-fill app-icon"></i>
            <i *ngIf="type === 'info'" class="bi bi-info-circle-fill app-icon"></i>
        </span>
        <p class="min-w-0 flex-1 whitespace-normal break-words pt-1 font-semibold leading-relaxed" [ngClass]="getTextClasses()">
            {{ message }}
        </p>
        <button type="button" class="inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg"
            [ngClass]="getButtonClasses()" (click)="onClose()" aria-label="關閉通知">
            <i class="bi bi-x-lg app-icon" aria-hidden="true"></i>
        </button>
    </div>
</div>
